module.exports = __webpack_public_path__ + "img/cent1000.e9fb940f.jpg";